export default __webpack_public_path__ + "static/media/Slack_Mark.cba0373d.svg";